import { grey } from '@mui/material/colors';

const baselightTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#0F2F51',
      light: '#abc1ff',
      dark: '#0F2F51',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#ECF2FF',
      light: '#E8F7FF',
      dark: '#dae6ff',
      contrastText: '#0F2F51',
    },
    success: {
      main: '#13DEB9',
      light: '#E6FFFA',
      dark: '#02b3a9',
      contrastText: '#ffffff',
    },
    info: {
      main: '#539BFF',
      light: '#EBF3FE',
      dark: '#1682d4',
      contrastText: '#ffffff',
    },
    error: {
      main: '#dd0000',
      light: '#ffeeee',
      dark: '#b30000',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#FFAE1F',
      light: '#FEF5E5',
      dark: '#ae8e59',
      contrastText: '#ffffff',
    },
    purple: {
      A50: '#EBF3FE',
      A100: '#6610f2',
      A200: '#557fb9',
    },
    grey: {
      100: '#F8F9FA', // Light grey
      200: '#F1F1F1', // Active Grey

      300: '#ECECEC', // Tab Background
      400: '#a0a4a8', // Place holder/ Light text
      500: '#BEC8D0', // Border

      600: '#787878', // Grey Text - Icon grey
    },
    text: {
      primary: '#434343',
      secondary: '#787878',
      contrastText: '#ffffff',
    },
    action: {
      disabledBackground: 'rgba(73,82,88,0.12)',
      hoverOpacity: 0.02,
      hover: '#f6f9fc',
    },
    divider: '#ebf1f6',
  },
};

const baseDarkTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#0F2F51',
      light: '#ECF2FF',
      dark: '#0F2F51',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#ECF2FF',
      light: '#E8F7FF',
      dark: '#dae6ff',
      contrastText: '#0F2F51',
    },
    success: {
      main: '#13DEB9',
      light: '#1B3C48',
      dark: '#02b3a9',
      contrastText: '#ffffff',
    },
    info: {
      main: '#539BFF',
      light: '#223662',
      dark: '#1682d4',
      contrastText: '#ffffff',
    },
    error: {
      main: '#dd0000',
      light: '#ffeeee',
      dark: '#b30000',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#FFAE1F',
      light: '#4D3A2A',
      dark: '#ae8e59',
      contrastText: '#ffffff',
    },
    purple: {
      A50: '#EBF3FE',
      A100: '#6610f2',
      A200: '#557fb9',
    },
    grey: {
      100: '#333F55',
      200: '#465670',
      300: '#7C8FAC',
      400: '#DFE5EF',
      500: '#EAEFF4',
      600: '#F2F6FA',
    },
    text: {
      primary: '#EAEFF4',
      secondary: '#7C8FAC',
    },
    action: {
      disabledBackground: 'rgba(73,82,88,0.12)',
      hoverOpacity: 0.02,
      hover: '#333F55',
    },
    divider: grey[100],
    background: {
      default: "#2A3447",
      dark: "#2A3547",
      paper: "#2A3447",
    },
  },
};

export { baseDarkTheme, baselightTheme };
